import React, {Component} from 'react';
import video_styles from './content.module.css';
import ReactPlayer from 'react-player';
import ContentTitle from '../../../ContentTitle/ContentTitle.js';
import ContentDescription from '../../../ContentDescription/ContentDescription.js';
import thumbnail959 from './thumbnails/thumbnail959.png'

class Content extends Component{
	state={
    	playing:true,
  	};
  
  	togglePlay=()=>{
    	this.setState({
			playing:this.state.playing===false
    	});
  	};

  	getVideoID=()=>{
    	return this.props.data.URL.substring(this.props.data.URL.lastIndexOf('/')+1);
  	};

	getThumbnailHD=()=>{
		if (this.getVideoID() === 'fSvpg6UzjcU'){
			return thumbnail959
		}
		return `https://img.youtube.com/vi/${this.getVideoID()}/maxresdefault.jpg`
	}
	getThumbnailSD=()=>{
		if (this.getVideoID() === 'fSvpg6UzjcU'){
			return thumbnail959
		}
		return `https://img.youtube.com/vi/${this.getVideoID()}/hqdefault.jpg`
	}

  	render(){
		let styles={...video_styles};
		Object.keys(this.props.content_styles || {}).forEach(k=>{
			styles[k]=(styles[k]===undefined?'':styles[k]+' ')+this.props.content_styles[k];
		});
		Object.keys(this.props.layout_styles || {}).forEach(k=>{
			styles[k]=(styles[k]===undefined?'':styles[k]+' ')+this.props.layout_styles[k];
		});


		let videoHD=(
			<ReactPlayer
				url={this.props.data.URL}
				playing={this.state.playing}
				width="100%"
				height="100%"
				controls={true}
				light={this.getThumbnailHD()}
			/>
		);
		let videoSD=(
			<ReactPlayer 
				className='shadow'
				url={this.props.data.URL}
				playing={this.state.playing}
				width="100%"
				height="100%"
				controls={true}
				light={this.getThumbnailSD()}
			/>
		);
 
		return (
			<div className={styles.container} style={{cursor:'default'}}>
				<div className={styles.header}>
					{this.props.feature===true
						?videoHD
						:videoSD}
				</div>
				<div className={styles.details}>
					<ContentTitle title={this.props.data.Title} styles={styles}/>
					<ContentDescription description={this.props.data.Description} styles={styles} feature={this.props.feature}/>
				</div>
			</div>
		);
  	}
}

export default Content;
